import React from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const OPERATORS = ["EQUALS", "NOT_EQUALS", "IN", "NOT_IN", "IS_EMPTY", "IS_NOT_EMPTY", "GREATER_THAN", "LESS_THAN", "CONTAINS"];

// Phase 3A. Edits form_fields.conditional_visibility_json (§10). Config is
// only STORED/validated this phase (referenced-field existence + no
// cycles, checked server-side by services/formConditionalLogicService.js);
// evaluation against real responses is a future phase's job. This editor
// itself also evaluates the config for the live preview (see
// DynamicFormRenderer.jsx) — but that is preview UX only, never trusted as
// the authoritative check.
export default function ConditionalLogicEditor({ value, otherFieldKeys, onChange, readOnly }) {
  const config = value || { logic: "AND", conditions: [] };

  const updateConfig = (next) => onChange(next.conditions.length ? next : null);

  const updateLogic = (logic) => updateConfig({ ...config, logic });

  const addCondition = () => {
    updateConfig({
      ...config,
      conditions: [...(config.conditions || []), { field_key: otherFieldKeys[0] || "", operator: "EQUALS", value: "" }],
    });
  };

  const updateCondition = (index, patch) => {
    const conditions = [...config.conditions];
    conditions[index] = { ...conditions[index], ...patch };
    updateConfig({ ...config, conditions });
  };

  const removeCondition = (index) => {
    const conditions = config.conditions.filter((_, i) => i !== index);
    updateConfig({ ...config, conditions });
  };

  return (
    <div className="conditional-logic-editor border rounded p-2">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong className="small">Conditional Visibility</strong>
        {!readOnly && <Button size="sm" variant="outline-primary" onClick={addCondition} disabled={!otherFieldKeys.length}>+ Condition</Button>}
      </div>

      {!otherFieldKeys.length && <div className="text-muted small">Add other fields first to reference them here.</div>}

      {config.conditions?.length > 1 && (
        <Form.Select size="sm" className="mb-2" style={{ maxWidth: 120 }} disabled={readOnly} value={config.logic} onChange={(e) => updateLogic(e.target.value)}>
          <option value="AND">ALL (AND)</option>
          <option value="OR">ANY (OR)</option>
        </Form.Select>
      )}

      {(config.conditions || []).map((condition, index) => (
        <Row key={index} className="g-1 align-items-center mb-1">
          <Col xs={4}>
            <Form.Select size="sm" disabled={readOnly} value={condition.field_key} onChange={(e) => updateCondition(index, { field_key: e.target.value })}>
              {otherFieldKeys.map((key) => <option key={key} value={key}>{key}</option>)}
            </Form.Select>
          </Col>
          <Col xs={4}>
            <Form.Select size="sm" disabled={readOnly} value={condition.operator} onChange={(e) => updateCondition(index, { operator: e.target.value })}>
              {OPERATORS.map((op) => <option key={op} value={op}>{op}</option>)}
            </Form.Select>
          </Col>
          <Col xs={3}>
            {!["IS_EMPTY", "IS_NOT_EMPTY"].includes(condition.operator) && (
              <Form.Control
                size="sm"
                disabled={readOnly}
                placeholder={["IN", "NOT_IN"].includes(condition.operator) ? "comma,separated" : "value"}
                value={Array.isArray(condition.value) ? condition.value.join(",") : (condition.value ?? "")}
                onChange={(e) => {
                  const raw = e.target.value;
                  const val = ["IN", "NOT_IN"].includes(condition.operator) ? raw.split(",").map((v) => v.trim()).filter(Boolean) : raw;
                  updateCondition(index, { value: val });
                }}
              />
            )}
          </Col>
          <Col xs={1}>
            {!readOnly && <Button size="sm" variant="outline-danger" onClick={() => removeCondition(index)}>×</Button>}
          </Col>
        </Row>
      ))}
    </div>
  );
}
